import React, { useState, useRef, useEffect } from "react";
import TableContainer from "@mui/material/TableContainer";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableCell from "@mui/material/TableCell";
import TableBody from "@mui/material/TableBody";
import moment from "moment-timezone";
import TableRow from "@mui/material/TableRow";
import { Modal, Form, Button, Row } from "react-bootstrap";
import ListGroup from "react-bootstrap/ListGroup";
import { FaPlusSquare, FaMinusSquare } from "react-icons/fa";

import { endPoints } from "../../../constant/Environment";
import Loader from "../../../components/Loader";
import { getAllData } from "../../../Utility/API";
import DashboardGameList from "./DashboardGameList";

const BetsCompetition = ({ userId }) => {
  const [isLoading, setIsLoading] = useState(false);

  const [gamelist, setGameLisst] = useState([]);

  function checkWin(winAmount, betAmount) {
    const result = winAmount - betAmount;
    return result >= 0;
  }

  const getGamePlayList = (type) => {
    setIsLoading(true);
    let url = `${endPoints.api.CASINO_GAME_LIST}/${type}/${userId}/0/500`;
    getAllData(url)
      .then((response) => {
        setIsLoading(false);
        const { status, data, message } = response;
        if (status === "success") {
          setGameLisst(data);
        }
      })
      .catch((err) => {
        setIsLoading(false);
        console.log(err);
      });
  };

  useEffect(() => {
    //  type 2 means - saga coin 1 means gold coin
    getGamePlayList(2);
  }, []);

  const exportPdf = () => {
    setIsLoading(true);
    fetch(`${endPoints.apiBaseUrl + `game/download/${userId}/pdf`}`, {
      method: "GET",
      responseType: "blob",
      headers: {
        "Content-Type": "application/json",
      },
    }).then(function (response) {
      setIsLoading(false);
      response.blob().then((blob) => {
        const link = document.createElement("a");
        const url = URL.createObjectURL(blob);
        link.href = url;
        link.download = "GameReport.pdf";
        link.click();
      });
    });
  };
  const exportCsv = () => {
    setIsLoading(true);
    fetch(`${endPoints.apiBaseUrl + `game/download/${userId}/csv`}`, {
      method: "GET",
      responseType: "blob",
      headers: {
        "Content-Type": "application/json",
      },
    }).then(function (response) {
      setIsLoading(false);
      response.blob().then((blob) => {
        const link = document.createElement("a");
        const url = URL.createObjectURL(blob);
        link.href = url;
        link.download = "GameReport.csv";
        link.click();
      });
    });
  };
  return (
    <>
      {isLoading && <Loader spinner={true} visible={isLoading} />}
      <div className="col-md-12">
        <div className="custom-table-data mt-4">
          <div style={{ display: "flex" }}>
            <h4 className="dark-gray f-bold" style={{ marginTop: "14px" }}>
              Play Game List{" "}
            </h4>
            <Button className="exportbtn" onClick={() => exportPdf()}>
              <img src="/images/icons/pdf.png" />
            </Button>
            <Button className="exportbtn" onClick={() => exportCsv()}>
              <img src="/images/icons/csv.png" />
            </Button>
            <Button
              onClick={() => {
                getGamePlayList(1);
              }}
              variant="primary"
              style={{ marginBottom: "5px" }}
            >
              Gold Coin
            </Button>
            <Button
              onClick={() => {
                getGamePlayList(2);
              }}
              variant="primary"
              style={{ marginBottom: "5px", marginLeft: "10px" }}
            >
              Saga Coin
            </Button>
          </div>

          <TableContainer component={Paper}>
            <Table size="small" aria-label="a dense table">
              <TableHead>
                <TableRow>
                  <TableCell>Date</TableCell>

                  <TableCell align="center">Game </TableCell>
                  <TableCell align="center">Coin Type </TableCell>

                  <TableCell align="center"> Bet Amount </TableCell>
                  <TableCell align="center">Win Amt </TableCell>
                  <TableCell align="center">Win/Loss </TableCell>
                  <TableCell align="center">Balance </TableCell>
                  {/* <TableCell align="center">Result </TableCell>
                                    <TableCell align="center">Actions </TableCell> */}
                </TableRow>
              </TableHead>
              <TableBody>
                {gamelist?.length > 0 &&
                  gamelist.map((row) => (
                    <TableRow
                      key={row.name}
                      sx={{
                        "&:last-child td, &:last-child th": {
                          border: 0,
                        },
                      }}
                    >
                      <TableCell component="th" scope="row">
                        {moment(row.created_on).format("MM/DD/YYYY")}
                      </TableCell>
                      <TableCell align="center">{row.gameName}</TableCell>
                      <TableCell align="center">
                        {row.playingWithCoin == "1" ? "Gold" : "Saga"}
                      </TableCell>

                      <TableCell align="center">
                        {row.betamount.toFixed(2)}
                      </TableCell>
                      <TableCell align="center">
                        {row.winamount.toFixed(2)}
                      </TableCell>
                      <TableCell align="center">
                        {checkWin(
                          parseFloat(row.winamount),
                          parseFloat(row.betamount)
                        ) ? (
                          <span
                            style={{
                              color: "green",
                              //   display: "flex",
                              alignItems: "center",
                            }}
                          >
                            <FaPlusSquare
                              color="green"
                              style={{ marginRight: "5px" }}
                            />
                            {`${(
                              parseFloat(row.winamount) -
                              parseFloat(row.betamount)
                            ).toFixed(2)}`}
                          </span>
                        ) : (
                          <span
                            style={{
                              color: "red",
                              //   display: "flex",
                              alignItems: "center",
                            }}
                          >
                            <FaMinusSquare
                              color="red"
                              style={{ marginRight: "5px" }}
                            />
                            {`${(
                              parseFloat(row.winamount) -
                              parseFloat(row.betamount)
                            ).toFixed(2)}`}
                          </span>
                        )}
                      </TableCell>
                      <TableCell align="center">
                        {row.balance.toFixed(2)}
                      </TableCell>
                    </TableRow>
                  ))}
              </TableBody>
            </Table>
          </TableContainer>
        </div>
        {gamelist?.length > 0 && (
          <div>
            <TableContainer component={Paper}>
              <Table size="small" aria-label="a dense table">
                <TableHead>
                  <TableRow>
                    <TableCell style={{ width: "40%" }}></TableCell>
                    <TableCell style={{ width: "30%", fontWeight: "bold" }}>
                      {" "}
                      Total Bet Amount:{" "}
                      {gamelist?.length > 0 &&
                        gamelist[0]?.totalbetamount.toFixed(2)}
                    </TableCell>
                    <TableCell style={{ width: "30%", fontWeight: "bold" }}>
                      Total Win Amount:{" "}
                      {gamelist?.length > 0 &&
                        gamelist[0]?.totalwinamount.toFixed(2)}
                    </TableCell>
                  </TableRow>
                </TableHead>
              </Table>
            </TableContainer>
          </div>
        )}
      </div>

      <DashboardGameList userId={userId} />
    </>
  );
};

export default BetsCompetition;
